import React from 'react';
import {assertNever} from '../../../shared/util';
import {PromptTextEditor} from './PromptTextEditor';
import {KeyClarificationsEditor} from './KeyClarificationsEditor';
import {AnalysisFieldsEditor} from './AnalysisFieldsEditor';
import {useFieldDefinitionEditorStore} from './AiFieldDefinitionEditor.state';
import {CategoriesEditor} from './CategoriesEditor';
import {MaxCategoriesEditor} from './MaxCategoriesEditor';
import {useAgentBuilderServerState} from './AgentBuilder.state';
import {useIsEnrichingAgent} from '../../../hooks/api/enrichment';
import {Divider} from '@chakra-ui/react';

export const AnalystFieldConfigEditor = () => {
  const {status, id: agentId} = useAgentBuilderServerState();
  const {data: isEnrichingAgent} = useIsEnrichingAgent({agentId});
  const isDisabled = status === 'published' || isEnrichingAgent;
  const {config, setConfig} = useFieldDefinitionEditorStore();
  if (!config) {
    return null;
  }

  switch (config.fieldType) {
    case 'boolean':
    case 'rating':
      return (
        <>
          <PromptTextEditor
            prompt={config.prompt}
            isDisabled={isDisabled}
            onPromptChange={(prompt) => setConfig({...config, prompt})}
          />
          <Divider />
          <AnalysisFieldsEditor
            config={config}
            isDisabled={isDisabled}
            onConfigChange={setConfig}
          />
          <Divider />
          <KeyClarificationsEditor
            config={config}
            isDisabled={isDisabled}
            onConfigChange={setConfig}
          />
        </>
      );

    case 'category':
      return (
        <>
          <CategoriesEditor
            config={config}
            isDisabled={isDisabled}
            onConfigChange={setConfig}
          />
          <Divider />
          <AnalysisFieldsEditor
            config={config}
            isDisabled={isDisabled}
            onConfigChange={setConfig}
          />
          <Divider />
          <KeyClarificationsEditor
            config={config}
            isDisabled={isDisabled}
            onConfigChange={setConfig}
          />
          <Divider />
          <MaxCategoriesEditor
            config={config}
            isDisabled={isDisabled}
            onConfigChange={setConfig}
          />
        </>
      );

    case 'legacyTeamSize':
    case 'research':
    case 'legacyResearch':
      throw new Error(
        `Field type not supported for analyst: ${config.fieldType}`
      );

    default:
      assertNever(config);
  }
};
